import axios from "axios";
import { handleResponse, handleError } from "./apiUtils";
// const baseUrl = process.env.API_URL + "/templates/";

const baseUrl = `${window.appLocalizer.apiUrl}/wprk/v1/submissions`;
const nonce = window.appLocalizer.nonce;

// const baseUrl = `http://localhost/wordpress/wp-json/wprk/v1/submissions`;
// const nonce = `5c74968270`;
// const cookie =
//   "wordpress_test_cookie=WP Cookie check; wordpress_logged_in_bbfa5b726c6b7a9cf3cda9370be3ee91=VigneshDeva06|1641619925|mDbcLbkXx6QCfpRISDBiFZQO7lySqhkI7LYQ1NAMTNm|b7b6ab30b0dbc572397bd597fa353f2f6beb02b330988ca3c0336054c0fa071c; wp-settings-time-1=1641447151";

const headers = {
  "X-WP-NONCE": nonce,
//  Cookie: cookie,
  "Content-Type": "application/json",
};

export function getFormSubmissions() {
  return axios
    .get(baseUrl, { headers, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}
export function getFormSubmission(submissionId) {
  const url = baseUrl + "/" + submissionId;
  return axios
    .get(url, { headers, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteFormSubmission(submissionId) {
  const url = baseUrl + "/" + submissionId;
  return axios
    .delete(url, { method: "DELETE", headers, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteFormSubmission_Bulk(submissionIds) {
  const url = baseUrl.slice(0, baseUrl.length - 1) + "/" + "bulk_delete";
  const data = JSON.stringify({ submissionIds });
  console.log("=======> To Calll", data);
  return axios
    .delete(url, { method: "DELETE", data, headers, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}

export function createFormSubmission(submissionBody) {
  console.log(
    "🚀 ~ file: formSubmissionApi.js ~ line 39 ~ createFormSubmission ~ submissionBody",
    submissionBody
  );
  const data = JSON.stringify({ form: submissionBody });
  return axios(baseUrl, {
    method: "POST",
    headers,
    data,
    withCredentials: true,
  })
    .then(handleResponse)
    .catch(handleError);
}
